// extracted by mini-css-extract-plugin
export default {"autoinput":"AutoCompleteRoles_autoinput__qI6d-"};